<template>
  <div id="JtDoughnutChart">
    <v-chart ref="chart" class="jtchart" :option="chartSettings" autoresize />
  </div>
</template>

<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { theme } from './../../styles/waste.project.json'

@Component({
  name: 'JtDoughnutChart',
  props: {
    data: {
      type: Array,
      required: false,
      default: []
    },
    centralTitle: {
      type: String,
      required: false,
      default: ''
    },
    centralTitleConst: {
      type: String,
      required: false,
      default: ''
    },
    formatterVisualTextValue: {
      type: Function,
      required: false
    },
    shouldShowLegend: {
      type: Boolean,
      required: false,
      default: false
    },
    shouldShowLabelParts: {
      type: Boolean,
      required: false,
      default: false
    },
    shouldShowPercentageInLabelParts: {
      type: Boolean,
      required: false,
      default: false
    },
    shouldShowTotalInTheMiddle: {
      type: Boolean,
      required: false,
      default: true
    },
    shouldShowValueInLabelParts: {
      type: Boolean,
      required: false,
      default: false
    }
  }
})
export default class JtDoughnutChart extends Vue {
  chartSettings = {
    tooltip: {
      trigger: 'item',
      valueFormatter: (value) => value.toLocaleString('pt-BR')
    },
    title: {
      left: 'center'
    },
    legend: {
      show: true,
      bottom: 0,
      left: 'center'
    },
    series: [
      {
        type: 'pie',
        radius: ['0%', '80%'],
        label: {
          show: true,
          position: 'inner'
        },
        emphasis: {
          label: {
            show: true
          },
          itemStyle: {
            shadowBlur: 0,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        },
        labelLine: {
          show: true
        },
        data: []
      }
    ]
  }

  mounted () {
    this.$refs.chart.theme = theme
    setTimeout(() => {
      this.dynamicConfigs()
      this.dataWatcher(this.data)
    }, 1)
  }

  getLabelPartFormat () {
    let labelPartFormat = ''
    if (this.shouldShowLabelParts) {
      labelPartFormat = '{b}'
    }

    if (this.shouldShowValueInLabelParts) labelPartFormat += '\n{c}'
    if (this.shouldShowPercentageInLabelParts) labelPartFormat += '\n{d}%'
    return labelPartFormat
  }

  dynamicConfigs () {
    const dynamicSettings = {
      title: {
        text: this.centralTitle || (this.centralTitleConst ? this.$gettext(this.centralTitleConst) : '')
      },
      legend: {
        show: this.shouldShowLegend
      },
      series: [
        {
          label: {
            show: true,
            formatter: this.getLabelPartFormat()
          },
          emphasis: {
            label: {
              show: true,
              formatter: this.getLabelPartFormat()
            }
          }
        }
      ]
    }

    if (this.formatterVisualTextValue) {
      dynamicSettings.tooltip = {
        valueFormatter: this.formatterVisualTextValue
      }
    }

    this.$refs.chart.setOption(dynamicSettings)
  }

  formatInformationToDoughnutData (information, idx) {
    const informationFormatted = {
      value: information.value,
      name: information.label || (information.labelConst ? this.$gettext(information.labelConst) : `${this.$gettext('NO_LABEL')}-${idx}`)
    }
    if (information.color) {
      informationFormatted.itemStyle = {
        color: information.color
      }
    }
    return informationFormatted
  }

  getSubtext (totalValue) {
    if (!this.shouldShowTotalInTheMiddle) return ''
    if (!this.formatterVisualTextValue) return totalValue
    return this.formatterVisualTextValue(totalValue)
  }

  @Watch('data', { deep: true })
  dataWatcher (newData) {
    const newDoughnutData = []
    let totalValue = 0
    if (newData && newData.length !== 0) {
      newData.forEach((record, idx) => {
        totalValue += record.value || 0
        newDoughnutData.push(this.formatInformationToDoughnutData(record, idx))
      })
    }

    const dynamicSettings = {
      title: {
      },
      series: [
        {
          data: newDoughnutData
        }
      ]
    }

    this.$refs.chart.setOption(dynamicSettings)
  }
}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';

#JtDoughnutChart {
  height: 100%;
  width: 100%;
  padding-top: 10px;
}
</style>
